import React from 'react'

const HeaderWrapper: React.FC = ({ children }) => {
	return <div className='user-projects__header'>{children}</div>
}
export { HeaderWrapper }
